import { Card, Box } from '@mui/material';
import { Handle, Position } from 'reactflow';

export default function HostNode({ data }) {
  return (
    <Card
      sx={{
        p: 2,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      <Handle type="target" position={Position.Top} id="host-target" />
      <Box fontWeight="bold">{data.title}</Box>
      <Handle type="source" position={Position.Bottom} id="host-source" />
    </Card>
  );
}
